<template>
  <figure
      class="mc-card-breadth"
      :class="{
        'mc-card-poker--show-border': hover === 'showBorder',
        'mc-card-poker--card-event' : clickTarget === 'card'
      }"
      @click="_onClick('card')"
  >
    <section
        class="mc-card-breadth__section"
        :class="{
          'is-pt': !!imgUrl
        }"
    >
      <aside class="mc-card-breadth__aside">
        <img
            class="mc-card-breadth__img"
            :src="imgUrl"
            v-if="!!imgUrl" />
        <h4 class="mc-card-breadth__title">
          {{title}}
        </h4>

        <p
            class="mc-card-breadth__description"
            v-if="!!text">{{text}}</p>
      </aside>

      <hr class="mc-card-breadth__line">
      <footer class="mc-card-breadth__footer" v-if="clickTarget === 'focusBtn'">
        <mc-btn size="small" @click="onClick('buyBtn')">购买</mc-btn>
        <mc-btn size="small" type="ghost" @click="onClick('trialBtn')">试用</mc-btn>
      </footer>
      <footer class="mc-card-breadth__footer" v-if="clickTarget === 'customBtn'">
        <mc-btn size="small" @click="onClick('customBtn')">{{btnText}}</mc-btn>
      </footer>
      <footer class="mc-card-breadth__footer" v-if="clickTarget === 'card'">
        <span v-if="status!=='error'">{{status}}</span>
        <span v-if="status==='error'" class="is-error">异常</span>
      </footer>
    </section>

  </figure>
</template>
<script type="text/ecmascript-6">
  import mcBtn from './base-btn';
  export default {
    name: 'mcCardBreadth',
    components: {mcBtn},
    props: {
      // showBorder 主色边框    showMask  模板&操作按钮
      hover: {
        type: String,
        default: 'showBorder'
      },
      //  card 状态文本   customBtn 文本
      clickTarget: {
        type: String,
        default: 'card'
      },
      btnText: {
        type: String,
        default: ''
      },
      imgUrl    : {
        type        : String,
        default     : ''
      },
      title     : {
        type        : String,
        default     : ''
      },
      text      : {
        type        : String,
        default     : ''
      },
      purchased : {
        type        : Boolean,
        default     : false
      },
      status    : {
        type        : String,
        default     : 'error'
      }
    },
    methods:{
      _onClick(type){
        if ( type === 'card' && this.clickTarget === 'card' ) {
          this.$emit('click',type);
        } else if( (type === 'buyBtn' || type === 'trialBtn') && this.clickTarget === 'focusBtn'){
          this.$emit('click',type);
        } else if (type ==='customBtn' && this.clickTarget === 'customBtn'){
          this.$emit('click',type);
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/card-breadth.vue